
/**
 * How long a change of access takes to reach compute: it caches its decision for 30 s per token (compute#21), and 27-30 s was
 * measured on staging (R4b). Every dialog and toast that promises a delay (revoke, grant, move to a project) says these words.
 */
const PROPAGATION_LAG_SECONDS = 30;
const PROPAGATION_LAG = `about ${PROPAGATION_LAG_SECONDS} seconds`;
/** The same lag as a number of milliseconds, for a refetch that must wait for compute's cache to expire. */
export const PROPAGATION_LAG_MS = PROPAGATION_LAG_SECONDS * 1000;
export const REVOKE_DONE_TEXT = `It can take ${PROPAGATION_LAG} to take effect.`;
export const REVOKE_DIALOG_LAG = `Access stops within ${PROPAGATION_LAG}.`;
export const GRANT_DONE_TEXT = `It takes effect within ${PROPAGATION_LAG}.`;

/** The toast line after resources moved to a project: people with a role there reach them (or it) within the lag. */
export function moveReachText(plural: boolean): string {
  return `People with a role on the project reach ${plural ? 'them' : 'it'} within ${PROPAGATION_LAG}.`;
}
